interface CoordinatesLike {
  latitude?: number | null
  longitude?: number | null
}

const MIN_LATITUDE = -90
const MAX_LATITUDE = 90
const MIN_LONGITUDE = -180
const MAX_LONGITUDE = 180

export function hasMapCoordinates(
  location?: CoordinatesLike | null,
): location is { latitude: number; longitude: number } {
  return location?.latitude !== undefined &&
    location.latitude !== null &&
    location.longitude !== undefined &&
    location.longitude !== null &&
    location.latitude >= MIN_LATITUDE &&
    location.latitude <= MAX_LATITUDE &&
    location.longitude >= MIN_LONGITUDE &&
    location.longitude <= MAX_LONGITUDE
}
